module.exports = __webpack_public_path__ + "static/media/shila_thumb.9397dedc.webp";